"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsFormatArgs = void 0;
const config_type_1 = require("../config-type");
const i18n_args_1 = require("./i18n-args");
/**
 * Input args to be used for a Points Format data queries.
 */
class PointsFormatArgs extends i18n_args_1.I18nArgs {
    constructor(_locale, _programName, _style) {
        super();
        this._locale = _locale;
        this._programName = _programName;
        this._style = _style;
    }
    getConfigType() {
        return config_type_1.ConfigType.POINTS_FORMAT;
    }
    getArgsMap() {
        return new Map([
            ['locale', this._locale],
            ['program_name', this._programName],
            ['style', this._style]
        ]);
    }
    get locale() {
        return this._locale;
    }
    get programName() {
        return this._programName;
    }
    get style() {
        return this._style;
    }
}
exports.PointsFormatArgs = PointsFormatArgs;
/**
 * Return the {@link Builder} instance used to build an {@link PointsFormatArgs} object.
 *
 * @return the builder instance
 */
PointsFormatArgs.Builder = class {
    /**
     * Sets the Locale within the {@link PointsFormatArgs} container.
     *
     * @param locale    Locale to be used for the config query.
     *
     * @return builder instance
     */
    withLocale(locale) {
        this.locale = locale;
        return this;
    }
    /**
     * Sets the Program Name within the {@link PointsFormatArgs} container.
     *
     * @param programName  Program Name to be used for the config query.
     *
     * @return builder instance
     */
    withProgramName(programName) {
        this.programName = programName;
        return this;
    }
    /**
     * Sets the style within the {@link PointsFormatArgs} container.
     *
     * @param style  Style to be used for the config query.
     *
     * @return builder instance
     */
    withStyle(style) {
        this.style = style;
        return this;
    }
    /**
     * Builds a {@link PointsFormatArgs} class type using the previously set
     * properties.
     *
     * @return {@link PointsFormatArgs} class instance
     */
    build() {
        return new PointsFormatArgs(this.locale, this.programName, this.style);
    }
};
//# sourceMappingURL=points-format-args.js.map